import { createTheme } from 'flowbite-react';

export const theme = createTheme({
    textInput: {
        field: {
            input: {
                sizes: {
                    sm: 'px-2 py-1 text-base',
                    md: 'px-2.5 py-2 text-base',
                    lg: 'p-4 text-base',
                },
                colors: {
                    primary:
                        'bg-gray-50 border-gray-300 text-gray-900 focus:border-primary-600 focus:ring-primary-600 outline-hidden',
                    dark: 'bg-gray-700 border-gray-600 text-gray-400 focus:border-primary-600 focus:ring-primary-600 outline-hidden',
                    light: 'placeholder-gray-300 bg-gray-700 border-gray-600 text-gray-400 focus:border-primary-600 focus:ring-primary-600 outline-hidden',
                },
            },
        },
    },
}).textInput;
